export interface DatesAssetsDetailModel {
  targetDeliveryDate?: string;
  actualDeliveryDate?: string;
  estimatedDeliveryFullDate?: string;
  actualDeliveryFullDate?: string;
}

export function datesAssetsDetailModelFactory(json?: any): DatesAssetsDetailModel {
  json = json || {};

  return {
    targetDeliveryDate: parseDateFromJSON(json.targetDeliveryDate) || null,
    actualDeliveryDate: parseDateFromJSON(json.actualDeliveryDate) || null,
    estimatedDeliveryFullDate: parseDateFromJSON(json.estimatedDeliveryFullDate) || null,
    actualDeliveryFullDate: parseDateFromJSON(json.actualDeliveryFullDate) || null,
  } as DatesAssetsDetailModel;
}

function parseDateFromJSON(date) {
  if (!date) return null;
  const matches = `${date}`.match(/^([0-9]{4}-[0-9]{2}-[0-9]{2})T?/i);
  if (!matches) return null;
  return matches[1] || null;
}
